import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { KmsService } from '../../../kms.service';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { SwMassageBoxService } from '../../../../../librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
@Component({
    selector: 'app-rules-add',
    templateUrl: './rules-add.component.html',
    styleUrls: ['./rules-add.component.css']
})
export class RulesAddComponent implements OnInit {
    // 模态框标题名称
    title = '';

    // 表单 规则配置详细信息
    rulesFormDatas = {
        prefixCode: '',  // 序列号前缀
        separatorSymbol: '',  // 分割符号
        serialNumberEn: '',  // 序列号英文标识
        serialNumberId: '',  // 序列号ID
        serialNumberLength: '',  // 序列号长度
        serialNumberName: '',  // 序列号说明
        startNumber: ''  // 起始数字
    }

    // 输入参数
    @Input() param: any;

    // 抛出事件
    @Output() callback = new EventEmitter();

    @ViewChild('modal') modal: SwModalframeComponent;
    constructor(
        private kmsService: KmsService,
        private swMaskService: SwMaskService,
        private message: SwMassageBoxService,
    ) { }

    ngOnInit() {
        if (this.param.upOrAdd == 'Add') {
            this.title = '新增规则配置信息';
        } else {
            this.title = '编辑规则配置信息';
            this.getSerialNumberById();
        }
    }

    // 根据规则配置ID查询详细信息
    getSerialNumberById() {
        this.kmsService.getSerialNumberById(this.param.serialNumberId).subscribe(
            result => {
                if (result.code == 200) {
                    this.rulesFormDatas = result.data;
                } else {
                    this.message.waringError(result.msg);
                }
            }
        )
    }

    // 表单提交方法
    onSubmit() {

        this.swMaskService.openMask("数据正在保存,请稍等...");


        this.kmsService.saveSerialNumberUpdate(this.rulesFormDatas).subscribe(
            result => {
                this.swMaskService.closeMask();
                if (result.code == 200) {
                    this.message.success('数据保存成功！');
                    this.modal.toggle();
                    // 回调
                    this.callback.emit(true);
                } else {
                    this.message.waringError(result.msg);
                }
            }
        )
    }

}
